// extracted by mini-css-extract-plugin
export default {"categoriesSection":"PopularCategories_categoriesSection__g1E87","categoriesGrid":"PopularCategories_categoriesGrid__2dm-+"};